var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SceneCanvas } from "../scenes/SceneCanvas";
var ScenePlayerBaseCanvas = /** @class */ (function (_super) {
    __extends(ScenePlayerBaseCanvas, _super);
    function ScenePlayerBaseCanvas() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ScenePlayerBaseCanvas;
}(SceneCanvas));
export { ScenePlayerBaseCanvas };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/ScenePlayerBaseCanvas.ts
// module id = 2224
// module chunks = 3